export default {
  deviceOfflineTimeout: 30000,
  userOfflineTimeout: 20000
}
